export default __webpack_public_path__ + "static/media/BrainBreak cards80.607ad7fd.png";